var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckEmailVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5063 83.7551L89.7487 43.5128L81.7573 35.5214L49.5063 67.7723L33.2381 51.5041L25.2467 59.4955L49.5063 83.7551ZM57.4977 114.579C49.6014 114.579 42.1808 113.081 35.2359 110.084C28.291 107.087 22.2499 103.02 17.1126 97.8828C11.9752 92.7455 7.90819 86.7043 4.91142 79.7594C1.91465 72.8145 0.41626 65.394 0.41626 57.4977C0.41626 49.6014 1.91465 42.1809 4.91142 35.2359C7.90819 28.291 11.9752 22.2499 17.1126 17.1126C22.2499 11.9753 28.291 7.90823 35.2359 4.91145C42.1808 1.91468 49.6014 0.41629 57.4977 0.41629C65.3939 0.41629 72.8145 1.91468 79.7594 4.91145C86.7043 7.90823 92.7454 11.9753 97.8828 17.1126C103.02 22.2499 107.087 28.291 110.084 35.2359C113.081 42.1809 114.579 49.6014 114.579 57.4977C114.579 65.394 113.081 72.8145 110.084 79.7594C107.087 86.7043 103.02 92.7455 97.8828 97.8828C92.7454 103.02 86.7043 107.087 79.7594 110.084C72.8145 113.081 65.3939 114.579 57.4977 114.579Z",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckEmailVerify);
export default __webpack_public_path__ + "static/media/check_email_verify.fb32a158c46bc320bba4823c0c75ae47.svg";
export { ForwardRef as ReactComponent };